
/* eslint-disable @typescript-eslint/camelcase */
import { Options, prop, Vue } from "vue-class-component";
import Tooltip from "@/app/ui/components/tooltip/index.vue";
import Discount from "./discount.vue";
import DetailEstimation from "./detail-estimation.vue";
import { PropType } from "vue";
import { BookingController } from "@/app/ui/controllers/BookingController";
import formatPriceIDR from "@/app/infrastructures/misc/common-library/FormatPriceIDR";
import { AccountController } from "@/app/ui/controllers/AccountController";
import ModalErrorBalance from "@/app/ui/views/shipment/booking/component/modal-error-balance.vue";
import { BalanceController } from "@/app/ui/controllers/BalanceController";
import { PromoConfigurationListData } from "@/domain/entities/PromoConfiguration";
import { EstimationPrice, ManualBooking } from "@/domain/entities/Booking";
import { GetEstimationPrice } from "@/data/payload/api/BookingRequest";
import { DetailDiscount } from "@/domain/entities/Tariff";
import formatPriceRM from "@/app/infrastructures/misc/common-library/FormatPriceRM";
import formatPrice from "@/app/infrastructures/misc/common-library/FormatPrice";
import { debounce } from "lodash";
import account from "@/app/ui/router/modules/account";
import { formatByCountry } from "@/app/infrastructures/misc/Utils";

interface DiscountInterface {
  status: boolean;
  data: PromoConfigurationListData;
}

class Props {
  modelValue = prop<ManualBooking>({
    default: () => new ManualBooking(),
    type: Object
  });
  isBooking = prop<boolean>({
    default: false
  });
  onNextPackage = prop<any>({
    default: Function as PropType<() => void>,
    type: Function
  });
  isDisabled = prop<boolean>({
    default: false,
    type: Boolean
  });
  bookingType = prop<string>({
    default: "",
    type: String
  });
  payload = prop<any>({
    default: {},
    type: Object
  });
  accountRefAndCommodity = prop<any>({
    default: {},
    type: Object
  });
  formType = prop<any>({
    default: "",
    type: String
  });
  discountData = prop<DiscountInterface>({
    default: {
      status: false,
      data: Object
    },
    type: Object
  });
  isCodRetail = prop<boolean>({
    default: false,
    type: Boolean
  });
  goodsValue = prop<any>({
    default: "0"
  });
  clientIdFromShipment = prop<number>({
    default: 0,
    type: Number
  });
  isInternational = prop<boolean>({
    default: false,
    type: Boolean
  });
  isCrossCountryCod = prop<boolean>({ default: false, type: Boolean });
  prefixCurrency = prop<string>({ required: true, type: String });
  destinationCurrencyLocale = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  emits: ["updateStatusErrorEmbargo"],
  components: {
    Tooltip,
    ModalErrorBalance,
    Discount,
    DetailEstimation
  },
  watch: {
    "payload.productName": function() {
      this.resetEstimasiDiscount();
    },
    "payload.destinationCity": function() {
      this.resetEstimasiDiscount();
    },
    "payload.sttGrossWeight": function() {
      this.resetEstimasiDiscount();
    },
    "payload.sttVolumeWeight": function() {
      this.resetEstimasiDiscount();
    },
    payloadGetEstimation: {
      handler() {
        this.onGetEstimation();
      },
      immediate: true,
      deep: true
    }
  }
})
class CheckTariffV2 extends Vue.with(Props) {
  isShow = false;

  unmounted() {
    BookingController.setDefaultEstimationPrice();
  }

  get isCODOnly() {
    return this.payload.isCOD === true && this.payload.isDFOD === false;
  }

  async showDetail() {
    if (
      this.formType === "manual" &&
      this.dataProfile.account_type === "partner"
    ) {
      this.isShow = !this.isShow;
      if (this.isShow) {
        const resultData = await this.getEstimationPrice();
        if (resultData) {
          this.setLabelTotalTarif = this.dataDetail.totalTariff;
        } else {
          this.setLabelTotalTarif = 0;
        }
      }
    }
  }

  async updateEstimationPrice() {
    if (this.isBalanceUnderLimitForPos) {
      this.balanceUnderLimit = true;
      return;
    }
    const resultData = await this.getEstimationPrice();
    if (resultData) {
      this.setLabelTotalTarif = this.dataDetail.totalTariff;
    } else {
      this.setLabelTotalTarif = 0;
    }

    this.balanceUnderLimit = this.isBalanceLessThenEstimationForPos;
    return resultData;
  }

  async getEstimationPrice() {
    if (!this.isDisabled) {
      this.showDiscountNominal = true;
      const piecesDelivery: any = [];
      this.payload.sttPieces.map((item: any) => {
        piecesDelivery.push({
          // eslint-disable-next-line @typescript-eslint/camelcase
          piece_length: item.stt_piece_length,
          // eslint-disable-next-line @typescript-eslint/camelcase
          piece_width: item.stt_piece_width,
          // eslint-disable-next-line @typescript-eslint/camelcase
          piece_height: item.stt_piece_height,
          // eslint-disable-next-line @typescript-eslint/camelcase
          piece_gross_weight: item.stt_piece_gross_weight
        });
      });

      const payload = new GetEstimationPrice({
        originId: this.payload.originDistrict,
        destinationId: this.payload.destinationDistrict,
        commodityId: this.accountRefAndCommodity.commodityId,
        productType: this.payload.productName,
        accountType: this.accountTypePayload,
        accountRefId:
          this.formType === "manual"
            ? AccountController.accountData.account_type_detail.id
            : this.payload.clientName.id,
        goodsPrice: this.payload.estimationPrice,
        insuranceType: this.payload.insurance,
        isWoodpacking: this.payload.isWoodpack,
        isHaveTaxId: !!this.payload.taxNumber,
        pieces: piecesDelivery,
        isCod: this.payload.isCOD,
        isDfod: this.payload.isDFOD,
        codHandling: "",
        isPad: this.payload.isPAD,
        codAmount: this.payload.codAmount || this.payload.estimationPrice,
        isDisablePromo:
          this.formType === "manual" &&
          AccountController.accountData.isPosAccount
            ? false
            : true,
        promoAppliedTo: "retail"
      });
      return BookingController.getEstimationPrice(payload);
    }
  }

  get payloadGetEstimation() {
    const piecesDelivery: any = [];
    this.payload.sttPieces.map((item: any) => {
      piecesDelivery.push({
        // eslint-disable-next-line @typescript-eslint/camelcase
        piece_length: item.stt_piece_length,
        // eslint-disable-next-line @typescript-eslint/camelcase
        piece_width: item.stt_piece_width,
        // eslint-disable-next-line @typescript-eslint/camelcase
        piece_height: item.stt_piece_height,
        // eslint-disable-next-line @typescript-eslint/camelcase
        piece_gross_weight: item.stt_piece_gross_weight
      });
    });

    return new GetEstimationPrice({
      originId: this.payload.originDistrict,
      destinationId: this.payload.destinationDistrict,
      commodityId: this.accountRefAndCommodity.commodityId,
      productType: this.payload.productName,
      accountType: this.accountTypePayload,
      accountRefId:
        this.formType === "manual"
          ? AccountController.accountData.account_type_detail.id
          : BookingController.manualBooking.clientId ||
            this.payload.clientName.id,
      goodsPrice: this.payload.estimationPrice,
      insuranceType: this.payload.insurance,
      isWoodpacking: this.payload.isWoodpack,
      isHaveTaxId: !!this.payload.taxNumber,
      pieces: piecesDelivery,
      isCod: this.payload.isCOD,
      isDfod: this.payload.isDFOD,
      codHandling: "",
      isPad: this.payload.isPAD,
      codAmount: this.payload.codAmount || this.payload.estimationPrice,
      isDisablePromo:
        this.formType === "manual" && AccountController.accountData.isPosAccount
          ? false
          : true,
      promoAppliedTo: "retail"
    });
  }

  onGetEstimation = debounce(async function(this: CheckTariffV2) {
    // specific case when shipmentId code CP--
    if (
      this.payload.sttShipmentId &&
      this.payload.sttShipmentId.startsWith("CP") &&
      this.clientIdFromShipment === 0 &&
      this.clientIdFromShipment !== this.payload.clientName?.id
    ) {
      return;
    }

    if (!this.isValidPayloadGetEstimation) return;
    this.showDiscountNominal = true;
    await BookingController.getEstimationPrice(this.payloadGetEstimation);
    this.updateTarif();
  }, 500);

  updateTarif() {
    if (this.isBalanceUnderLimitForPos) {
      this.balanceUnderLimit = true;
      return;
    }
    this.setLabelTotalTarif = this.dataDetail.totalTariff;
    this.balanceUnderLimit = this.isBalanceLessThenEstimationForPos;
  }

  get isValidPayloadGetEstimation() {
    const {
      originDistrict,
      destinationDistrict,
      productName,
      estimationPrice,
      clientName,
      insurance,
      sttPieces
    } = this.payload;

    const accountRefId =
      this.formType === "manual"
        ? AccountController.accountData.account_type_detail?.id
        : BookingController.manualBooking.clientId || clientName?.id;

    const sttPiecesValid = sttPieces.every(
      ({
        stt_piece_length,
        stt_piece_width,
        stt_piece_height,
        stt_piece_gross_weight
      }: any) =>
        [
          stt_piece_length,
          stt_piece_width,
          stt_piece_height,
          stt_piece_gross_weight
        ].every(Boolean)
    );

    return [
      originDistrict,
      destinationDistrict,
      this.accountRefAndCommodity?.commodityId,
      productName,
      this.accountTypePayload,
      accountRefId,
      estimationPrice,
      insurance,
      sttPiecesValid
    ].every(Boolean);
  }

  get accountTypePayload() {
    let accountType = this.formType;
    if (this.formType === "manual") {
      accountType =
        AccountController.accountData.account_type === "partner"
          ? "pos"
          : AccountController.accountData.account_type;
    }

    return accountType;
  }

  get dataDetail() {
    if (!this.isDisabled) {
      return {
        ...BookingController.estimationPrice,
        discountBoards:
          BookingController.estimationPrice.listDiscount.filter(
            (item: DetailDiscount) =>
              item.pdcCategory === "tactical" || item.pdcCategory === "campaign"
          ) || []
      };
    }

    return {
      totalTariff: 0,
      discount: 0,
      isPromo: false
    };
  }

  bigLabelTotalTariff = 0;
  get getLabelTotalTarif() {
    return this.bigLabelTotalTariff;
  }

  set setLabelTotalTarif(value: number) {
    this.bigLabelTotalTariff = value;
  }
  get setLabelTotalTarif() {
    return this.bigLabelTotalTariff;
  }

  isOpenTooltip = false;
  onOpenTooltip(value: boolean) {
    this.isOpenTooltip = value;
  }

  onCloseAnywhere(value: boolean) {
    this.isShow = value;
  }

  currency(curr: number) {
    if (this.isCrossCountryCod) {
      const formatted = formatByCountry(curr, {
        type: "weight",
        country: this.modelValue.destinationCountry.code,
        fractionDigits: 6,
        minFractionDigits: 0
      });

      return `${this.prefixCurrency}${formatted}`;
    }

    return this.accountIsNonForeign
      ? this.currencyRupiah(curr)
      : this.currencyRinggit(curr);
  }

  currencyRupiah(curr: number) {
    if (curr) {
      return formatPrice(curr);
    }
    return formatPrice(0);
  }

  currencyRinggit(curr: number) {
    if (curr) {
      return formatPriceRM(curr);
    }
    return formatPriceRM(0);
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  get balanceData() {
    return BalanceController.balanceData;
  }

  balanceUnderLimit = false;
  get isBalanceUnderLimitForPos() {
    if (this.formType === "manual") {
      return (
        BalanceController.balanceData.walletBalance <
          this.dataProfile.limit_rule_min_balance &&
        this.dataProfile.account_type === "partner"
      );
    }
    return false;
  }
  get isBalanceLessThenEstimationForPos() {
    return (
      BalanceController.balanceData.walletBalance < this.setLabelTotalTarif &&
      this.dataProfile.account_type === "partner"
    );
  }

  get isErrorEmbargo() {
    return BookingController.isErrorEmbargo;
  }

  showDiscountNominal = false;
  get isDiscountActive() {
    return this.discountData.status || this.dataDetail.isPromo;
  }

  resetEstimasiDiscount() {
    this.setLabelTotalTarif = 0;
    BookingController.setEstimationPrice(
      new EstimationPrice({
        totalTariffAfterDiscount: 0,
        totalTariff: 0,
        isPromo: false
      })
    );
  }

  get formatPriceMasked() {
    return `${this.prefixCurrency} -`;
  }

  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }
}

export default CheckTariffV2;
